import React from 'react'

import { SvgWarning } from '@chilipiper/icons/src/design-system/Warning'

import { Alert, CustomAlertProps } from './Alert'

export const WarningAlert = (props: CustomAlertProps) => {
  return <Alert icon={SvgWarning} iconColor='icon/warning' {...props} />
}
